import PredefinedStrategyTiles from '../predefinedStrategyTiles'
import PlChart from '../../../pages/home/plChart'
import { memo, useEffect, useMemo } from 'react'
import useOnStrategySelected from '../../../hooks/useonStrategySelected'
import { OptionChainViewKey } from '../../../assets/constants'
import { fetchStrategyTemplates } from '../../../services/apis/strategyTemplate'
import { selectStrategyTemplates } from '../../../selectors/strategyTemplate'
import { useSelector } from 'react-redux'
import { selectBasketId, selectStrategyBuilderMode, selectTradeOrders } from '../../../selectors/strategyBuilder'
import LivePayoffContainer from '../../payoffContainer/livePayoffContainer'
import { useCombineBasketAnalyzeAndLegOrders } from '../../../hooks/useCombineBasketAnalyzeAndLegOrders'
import { selectPositions } from '../../../selectors/positions'
import { Box } from '@mui/material'
import SubtleShimmer from '../../common/SubtleShimmer'
import StrategyPayoffSkeleton from '../StrategyPayoffSkeleton'
import StrategyTilesSkeleton from '../StrategyTilesSkeleton'

export type StrategyBuilderPayoffViewProps = {
    simulator: boolean
}

const StrategyBuilderPayoffView: React.FC<StrategyBuilderPayoffViewProps> = ({ simulator }) => {
    const strategyTemplates = useSelector(selectStrategyTemplates)

    const tradeOrders = useSelector(selectTradeOrders);
    const strategyBuilderMode = useSelector(selectStrategyBuilderMode);
    const basketId = useSelector(selectBasketId);
    const positions = useSelector(selectPositions);

    const basketPositions = useMemo(() => (positions??[]).filter(p => p.basketId === basketId), [positions, basketId])

    const optionChainViewKey = simulator ? OptionChainViewKey.HISTORICAL : OptionChainViewKey.LIVE;
    const { allOrders = [], analyzeOrders = [] } = useCombineBasketAnalyzeAndLegOrders()
    useEffect(() => {
        if (strategyTemplates.length === 0) {
            fetchStrategyTemplates()
        }
    }, [])

    const { loading } = useOnStrategySelected()
    const nonEmptyOrders = useMemo(() => {
        return simulator ? (Boolean(allOrders.length) || Boolean(analyzeOrders.length)) : (Boolean(tradeOrders?.length) || ['analyze', 'squareOff'].includes(strategyBuilderMode))
    }, [allOrders.length, analyzeOrders.length, simulator, tradeOrders, strategyBuilderMode])

    const showPayoffContent = nonEmptyOrders || basketPositions.length > 0
    const plChart = useMemo(() => simulator ? <PlChart optionChainViewKey={optionChainViewKey} /> : <LivePayoffContainer />, [simulator, optionChainViewKey])
    const tiles = useMemo(() => <PredefinedStrategyTiles optionChainViewKey={optionChainViewKey} />, [optionChainViewKey])

    return (
        <Box sx={{ position: 'relative', width: '100%', height: '100%', flex: 1, minHeight: 0 }}>
            {showPayoffContent ? plChart : tiles}
            {loading && (
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        zIndex: 2,
                        bgcolor: 'background.paper'
                    }}
                >
                    <SubtleShimmer loading fill>
                        {showPayoffContent ? <StrategyPayoffSkeleton /> : <StrategyTilesSkeleton />}
                    </SubtleShimmer>
                </Box>
            )}
        </Box>
    )
}
export default memo(StrategyBuilderPayoffView)
